import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import { motion } from "framer-motion";
import CardHeadMenu from "../Card/CardHeadMenu/CardHeadMenu";
import Swal from "sweetalert2";
import configServ from "../../services/config";
import { styled } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DOMPurify from "dompurify";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#1976d2", // MUI blue
  color: "#fff",
  fontWeight: "bold",
}));

const StyledEvenRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#f5f5f5", // light grey
}));

const FaqsPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyId = parseInt(queryParams.get("company_id"), 10);
  const itemId = parseInt(queryParams.get("id"), 10);
  const titlee = queryParams.get("title");

  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false); // For update state
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    status: true,
  });
  const [validationErrors, setValidationErrors] = useState({});

  console.log("companyId:", companyId, "itemId:", itemId);

  // Handle popup (open/close form)
  const handlePopup = () => {
    try {
      if (isCreate === true) {
        clear();
      }
      setIsCreate(!isCreate);
    } catch (error) {
      console.log(error);
    }
  };

  // Clear form fields
  const clear = () => {
    setFormData({
      question: "",
      answer: "",
      status: true,
    });
    setValidationErrors({});
    setIsEdit(false);
  };

  // Handle input changes
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validate form fields
  const validate = () => {
    const errors = {};
    if (!formData.question?.trim()) errors.question = "Question is required.";
    if (!formData.answer?.trim()) errors.answer = "Answer is required.";
    return errors;
  };

  // Submit form
  const handleSubmit = async () => {
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    try {
      const payload = {
        ...formData,
        company_id: companyId,
        courses_id: itemId,
      };

      if (isEdit) {
        console.log("Updating FAQ:", payload);
        const res = await configServ.updateFaq(formData.id, payload);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Course Faq's updated successfully.",
          });
          clear();
          setIsCreate(false);
          fetchfaqs();
        }
      } else {
        // Make create API call here
        console.log("Creating FAQ:", payload);
        const res = await configServ.createFaq(payload);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Course Faq's created successfully.",
          });
          clear();
          setIsCreate(false);
          fetchfaqs();
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const [faqs, setFaqs] = useState([]);
  const [loader, setLoader] = useState(true);

  const fetchfaqs = async () => {
    try {
      setLoader(true);
      const payload = {
        company_id: companyId,
        courses_id: itemId,
      };

      const res = await configServ.getFaqs(payload);
      if (res.success) {
        setFaqs(res.data);
      } else {
        setFaqs([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchfaqs();
  }, []);

  const handleEdit = (faq) => {
    console.log("faq", faq);
    setIsCreate(true);
    setFormData(faq);
    setIsEdit(true);
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }], // ✅ Text and background color
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"], // remove formatting
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  // Helper: Convert HTML to plain text
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  // Helper: Truncate text to 2-3 lines
  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };
  const truncateHtml = (html, maxLength = 200) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    const truncated =
      text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    return `<div>${truncated}</div>`; // wrap it so innerHTML can render
  };

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"FAQ'S"}
        handlePopup={handlePopup}
        create={isCreate}
      />

      {isCreate === true && (
        <Container>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-start"
            spacing={1}
          >
            <Grid item xs={6} md={3}></Grid>
            <Grid
              container
              item
              xs={6}
              md={9}
              justifyContent={"flex-start"}
            ></Grid>
          </Grid>

          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              borderRadius: "10px",
              border: "none",
            }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              spacing={1}
            >
              <Grid container spacing={2}>
                {/* Question Title with ReactQuill */}
                <Grid item xs={12} md={12}>
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      marginBottom: "4px",
                      display: "block",
                    }}
                  >
                    Question
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={formData.question || ""}
                    onChange={(value) =>
                      changeHandler({ target: { name: "question", value } })
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    style={{
                      backgroundColor: "white",
                      minHeight: "120px",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  />
                  {validationErrors.question && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {validationErrors.question}
                    </p>
                  )}
                </Grid>

                {/* Answer with ReactQuill */}
                <Grid item xs={12} md={12}>
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      marginBottom: "4px",
                      display: "block",
                    }}
                  >
                    Answer
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={formData.answer || ""}
                    onChange={(value) =>
                      changeHandler({ target: { name: "answer", value } })
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    style={{
                      backgroundColor: "white",
                      minHeight: "120px",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  />
                  {validationErrors.answer && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {validationErrors.answer}
                    </p>
                  )}
                </Grid>

                {/* Checkbox */}
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="status"
                        checked={Boolean(formData.status)}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            status: e.target.checked,
                          }))
                        }
                      />
                    }
                    label="Active"
                  />
                </Grid>
              </Grid>

              {/* Buttons */}
              <Grid
                container
                alignItems="flex-end"
                justifyContent="flex-end"
                mt={2}
                spacing={1}
              >
                <Grid
                  container
                  item
                  xs={12}
                  md={isEdit ? 12 : 8}
                  justifyContent={"flex-start"}
                ></Grid>
                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    color="secondary"
                    onClick={clear}
                    variant="contained"
                    size="small"
                    title="Reset"
                    startIcon={<RotateLeftIcon />}
                  >
                    Reset
                  </Button>
                </Grid>
                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    variant="contained"
                    color={isEdit ? "success" : "primary"}
                    startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                    size="small"
                  >
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </motion.div>
        </Container>
      )}

      <Box display="flex" justifyContent="center" alignItems="center" mt="5">
        <Typography variant="h4">{titlee}</Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Sn.no</StyledTableCell>
              <StyledTableCell>Question</StyledTableCell>
              <StyledTableCell>Answer</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loader ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : faqs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body1">No Data Found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              faqs.map((faq, index) => {
                const RowComponent = index % 2 === 0 ? StyledEvenRow : TableRow;
                return (
                  <RowComponent key={faq.id}>
                    <TableCell>{index + 1}</TableCell>

                    {/* Question */}
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                        p: 1,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: faq.question }}
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 4,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      />
                    </TableCell>

                    {/* Answer */}
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                        p: 1,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 4,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      />
                    </TableCell>

                    {/* Status */}
                    <TableCell>
                      {faq.status === 1 || faq.status === "1" ? "✅" : "❌"}
                    </TableCell>

                    {/* Action */}
                    <TableCell>
                      <IconButton onClick={() => handleEdit(faq)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </RowComponent>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default FaqsPage;
